<div class="row" *ngIf="!noCharacteristicsData;else noData">
  <div>
    <table style="margin-top: 2rem;" class="width">
      <tr class="money-header">
        <th class="row-header">Fundamental</th>
        <th>{{fundId}}</th>
        <th>
          <div class="tool-tip-cell">
            <label>Benchmark</label>
            <c11n-tooltip [autoOrientation]="false" colorMode="on-light" direction="left" labelText="Benchmark">
              <span c11nTooltipContent>{{ moneyMarketCharacteristic?.benchmarkShortName || '(Benchmark)' }}</span>
            </c11n-tooltip>
          </div>
        </th>
      </tr>
      <tr class="money-table">
        <td class="row-header">Number of holdings</td>
        <td data-rpa-tag-id="symbolNumberOfHoldings">
          {{ moneyMarketCharacteristic?.fund?.numberOfBonds ? moneyMarketCharacteristic?.fund?.numberOfBonds : '&mdash;'
          }}
        </td>
        <td data-rpa-tag-id="benchmarkNumberOfHoldings">
          {{ moneyMarketCharacteristic?.benchmark?.numberOfBonds ? moneyMarketCharacteristic?.benchmark?.numberOfBonds :
          '&mdash;' }}
        </td>
      </tr>
      <tr class="money-table">
        <td class="row-header"><a class="link money-link" role="dialog" tabindex="0"
            (click)="setDialogInfo('Average maturity (money market funds only)');moneyMarketModalDialog.openModalDialog();" href="javascript:void(0)">
            Average maturity</a></td>
        <td data-rpa-tag-id="symbolAverageMaturity">
          {{ moneyMarketCharacteristic?.fund?.averageMaturity ? moneyMarketCharacteristic?.fund?.averageMaturity :
          '&mdash;' }}
        </td>
        <td data-rpa-tag-id="benchmarkAverageMaturity">
          {{ moneyMarketCharacteristic?.benchmark?.averageMaturity ?
          moneyMarketCharacteristic?.benchmark?.averageMaturity: '&mdash;' }}
        </td>
      </tr>
      <tr class="money-table">
        <td class="row-header">Weighted average life</td>
        <td data-rpa-tag-id="symbolWeightedAverageLife">
          {{ portfolioModel?.holdingDetailMoneyMarket?.weightedAverageLife ?
          (portfolioModel?.holdingDetailMoneyMarket?.weightedAverageLife | VMFDays) : '&mdash;'}}
        </td>
        <td data-rpa-tag-id="benchmarkWeightedAverageLife">
          {{ moneyMarketCharacteristic?.benchmark?.spreadWeightedAverageMaturity ?
          moneyMarketCharacteristic?.benchmark?.spreadWeightedAverageMaturity : '&mdash;' }}
        </td>
      </tr>
      <tr class="money-table" *ngIf="portfolioModel?.profileData?.isTaxExemptMoneyMarketFund">
        <td class="row-header"><a class="link money-link" role="dialog" tabindex="0"
            (click)="setDialogInfo('Alternative minimum tax (AMT)');moneyMarketModalDialog.openModalDialog();" href="javascript:void(0)">Alternative minimum tax (AMT)*</a></td>
        <td data-rpa-tag-id="symbolAMT">
          {{ moneyMarketCharacteristic?.fund?.alternativeMinimumTax ?
          moneyMarketCharacteristic?.fund?.alternativeMinimumTax + '%': '&mdash;' }}
        </td>
        <td data-rpa-tag-id="benchmarkAMT">
          {{ moneyMarketCharacteristic?.benchmark?.alternativeMinimumTax ?
          moneyMarketCharacteristic?.benchmark?.alternativeMinimumTax + '%': '&mdash;' }}
        </td>
      </tr>
      <tr class="money-table">
        <td class="row-header">Fund total net assets as of
          {{ moneyMarketCharacteristic?.fund?.totalNetAssetsDate | ESTPipe }}</td>
        <td data-rpa-tag-id="symbolFundNetAssets">
          {{ moneyMarketCharacteristic?.fund?.totalNetAssets ? (moneyMarketCharacteristic?.fund?.totalNetAssets |
          amount): '&mdash;' }}
        </td>
        <td data-rpa-tag-id="benchmarkFundNetAssets">
          {{ moneyMarketCharacteristic?.benchmark?.totalNetAssets ?
          (moneyMarketCharacteristic?.benchmark?.totalNetAssets | amount): '&mdash;' }}
        </td>
      </tr>
      <tr class="money-table" *ngIf="portfolioModel?.profileData?.hasMoreThan1ShareClass">
        <td class="row-header">Share class total net assets</td>
        <td>
          {{ moneyMarketCharacteristic?.fund?.shareClassTotalNetAssets ?
          (moneyMarketCharacteristic?.fund?.shareClassTotalNetAssets| amount): '&mdash;' }}
        </td>
        <td>
          {{ moneyMarketCharacteristic?.benchmark?.shareClassTotalNetAssets ?
          (moneyMarketCharacteristic?.benchmark?.shareClassTotalNetAssets| amount): '&mdash;' }}
        </td>
      </tr>
    </table>
  </div>
</div>

<c11n-modal-dialog modalId="moneyMarketModal" [headingText]="title" id="averageMaturityPopupDialogTitle" id="alternativeMinimumTaxPopupDialogTitle" #moneyMarketModalDialog>
  <div c11n-modal-dialog-body>
    <p id="averageMaturityPopupDialogDesc"
    *ngIf="title == 'Average maturity (money market funds only)'" [innerHTML]="averageMaturity?.contentValue"></p>
    <p id="alternativeMinimumTaxPopupDialogDesc"
    *ngIf="title == 'Alternative minimum tax (AMT)'" [innerHTML]="alternativeMinimumTax?.contentValue"></p>
  </div>
</c11n-modal-dialog>

<ng-template #noData>
  <p *ngIf="noCharacteristicsData" class="no-data">This information is temporarily unavailable.</p>
</ng-template>
